export default __webpack_public_path__ + "static/images/jennie_05.png";